<template>
  <div class="appraiseDialog">
    <el-dialog title="评分" :visible.sync="dialogVisible" width="30%" center>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="总体评估" name="first">
          <div class="menu1">
            <div class="block" style="border-bottom: 1px solid #E8E8E8;padding-bottom: 20px;">
              <div class="demonstration">总体评价</div>
              <div class="icon">
                <el-rate v-model="allScore"></el-rate>
              </div>
            </div>
            <div class="block" v-for="(item, index) in allAppraise[0] ? allAppraise[0].ItemList : []" :key='index'>
              <div class="demonstration">{{item.ITEMNAME}}</div>
              <div class="icon">
                <el-rate v-model="allScoreList[0][index]"></el-rate>
              </div>
            </div>
            <div class="block">
              <div class="demonstration">总体评价</div>
              <div class="icon">
                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea">
                </el-input>
              </div>
            </div>
            <div style="height: 20px;"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="单项评估" name="second">
          <div class="menu2">
            <div class="block">
              <span class="demonstration" style="line-height: 30px;">选择评价人员</span>
              <div class="icon">
                <el-select size="small" v-model="people" placeholder="请选择">
                  <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="height: 20px;"></div>
            <el-scrollbar style="height: 300px;" v-if="options[0].value === people">
              <template v-for="(item, index) in partAppraise ? partAppraise : []">
                <el-card :key="index" shadow="never" :body-style="{ padding: '20px' }">
                  <div class="title">{{item.GROUPNAME}}</div>
                  <div class="block" v-for="(obj, num) in item.ItemList" :key="num">
                    <span class="demonstration">{{obj.ITEMNAME}}</span>
                    <el-rate class="icon" v-model="CpartScoreList[index][num]"></el-rate>
                  </div>
                </el-card>
                <div :key="item.groupId" style="height: 5px;"></div>
              </template>
            </el-scrollbar>
            <el-scrollbar style="height: 300px;" v-if="options[1].value === people">
              <template v-for="(item, index) in partAppraise ? partAppraise : []">
                <el-card :key="index" shadow="never" :body-style="{ padding: '20px' }">
                  <div class="title">{{item.GROUPNAME}}</div>
                  <div class="block" v-for="(obj, num) in item.ItemList" :key="num">
                    <span class="demonstration">{{obj.ITEMNAME}}</span>
                    <el-rate class="icon" v-model="EpartScoreList[index][num]"></el-rate>
                  </div>
                </el-card>
                <div :key="item.groupId" style="height: 5px;"></div>
              </template>
            </el-scrollbar>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer" v-show="activeName === 'first'">
        <el-button @click="dialogVisible = false">返回</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-show="activeName === 'second'">
        <el-button @click="backStep">上一步</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import {
    AddScoreItem,
    AddScoreGroup,
    DelScoreItem,
    DelScoreGroup,
    GetScoreGroup,
    SaveTaskScoreInfo,
    GetTaskScoreInfo
  } from '@/api/modules/basicData/task'
  export default {
    data() {
      return {
        dialogVisible: false, //dialog是否显示
        allScore: null, //总体评价星级
        value: null,
        textarea: '', //评论内容
        people: '', //选择人的id
        activeName: 'first', //dialog页数
        scoreGroup: [], //评价的模板
        allScoreList: [], //总体评价星级集合
        CpartScoreList: [], //创建人分类评价二维数组
        EpartScoreList: [], //执行人分类评价二维数组
      }
    },
    mounted() {
      this.getScoreGroup()
    },
    methods: {
      getScoreGroup() {
        GetScoreGroup().then(res => {
          this.scoreGroup = res
          console.log(this.scoreGroup)
        })
      },
      submit() {
        if (!this.people) {
          this.$message({
            message: '请选择评价的人员',
            type: 'warning'
          });
          return
        }
        let DetailList = []
        this.allAppraise.forEach((item, index) => {
          item.ItemList.forEach((obj, num) => {
            let detail = {
              TASKID: this.curTask.ID,
              GROUPID: item.ID,
              ITEMID: obj.ID,
              SCORE: this.allScoreList[index][num],
            }
            DetailList.push(detail)
          })
        })
        this.partAppraise.forEach((item, index) => {
          item.ItemList.forEach((obj, num) => {
            let detail = {
              TASKID: this.curTask.ID,
              GROUPID: item.ID,
              ITEMID: obj.ID,
              SCORE: this.CpartScoreList[index][num],
              ...this.personList[0]
            }
            let detail1 = {
              TASKID: this.curTask.ID,
              GROUPID: item.ID,
              ITEMID: obj.ID,
              SCORE: this.EpartScoreList[index][num],
              ...this.personList[1]
            }
            DetailList.push(detail)
            DetailList.push(detail1)
          })
        })
        let info = {
          TASKID: this.curTask.ID,
          SCORE: this.allScore,
          COMMENT: this.textarea,
          CREATETIME: new Date(),
          DetailList,
          ...this.createUserInfo
        }
        console.log(JSON.stringify(info))
        SaveTaskScoreInfo(info).then(res => {
          console.log(res)
        })

        // let scoreInfo = {
        //   TaskId: this.curTask.ID,
        //   Person: this.userInfo
        // }
        // console.log(JSON.stringify(scoreInfo))
        // GetTaskScoreInfo(scoreInfo).then(res => {
        //   console.log(res)
        // })
      },
      handleClick() { //选择tab触发
        // console.log(this.curTask)
        console.log(this.allAppraise)
        console.log(this.partAppraise)
        // console.log(this.people)
      },
      backStep() { //上一步
        this.activeName = 'first'
      },
      nextStep() { //下一步
        this.activeName = 'second'
      }
    },
    computed: {
      ...mapState({
        curTask: state => state.task.curTask,
        curUser: state => state.user
      }),
      options() { //选择器选项 创建人&&执行人
        const task = this.curTask
        let obj = {
          value: task.CREATEUSERID,
          label: task.CREATEUSERNAME + "（创建人）"
        }
        let obj1 = {
          value: task.EXCUTEUSERID,
          label: task.EXCUTEUSERNAME + "（执行人）"
        }
        return [obj, obj1]
      },
      personList() { //创建人&&执行人完整对象
        const task = this.curTask
        return [{
          TOUSERID: task.CREATEUSERID,
          TOUSERNAME: task.CREATEUSERNAME,
          TODEPTID: task.CREATEDEPTID,
          TODEPTNAME: task.CREATEDEPTNAME,
          TOCOMPANYID: task.CREATECOMPANYID,
          TOCOMPANYNAME: task.CREATECOMPANYNAME
        }, {
          TOUSERID: task.EXCUTEUSERID,
          TOUSERNAME: task.EXCUTEUSERNAME,
          TODEPTID: task.EXCUTEDEPTID,
          TODEPTNAME: task.EXCUTEDEPTNAME,
          TOCOMPANYID: task.EXCUTECOMPANYID,
          TOCOMPANYNAME: task.EXCUTECOMPANYNAME
        }]
      },
      userInfo() {//创建人对象
        let user = this.curUser
        return {
          ID: user.userId,
          NAME: user.realName,
          DEPTID: user.departmentId,
          DEPTNAME: user.departmentName,
          COMPANYID: user.companyId,
          COMPANYNAME: user.companyName
        }
      },
      createUserInfo() {//创建人对象
        let user = this.curUser
        return {
          CREATEUSERID: user.userId,
          CREATEUSERNAME: user.realName,
          CREATEDEPTID: user.departmentId,
          CREATEDEPTNAME: user.departmentName,
          CREATECOMPANYID: user.companyId,
          CREATECOMPANYNAME: user.companyName
        }
      },
      allAppraise() { //总体评价
        return this.scoreGroup.filter(obj => {
          return obj.SCORETYPE === 0
        })
      },
      partAppraise() { //分类评价
        return this.scoreGroup.filter(obj => {
          return obj.SCORETYPE === 1
        })
      }
    },
    watch: {
      allAppraise(newValue) {
        this.allScoreList = []
        newValue.forEach((item, num) => {
          this.allScoreList.push([])
          item.ItemList.forEach((obj, index) => {
            this.allScoreList[num].push(0)
          })
        })
      },
      partAppraise(newValue) {
        this.CpartScoreList = []
        this.EpartScoreList = []
        newValue.forEach((item, num) => {
          this.CpartScoreList.push([])
          this.EpartScoreList.push([])
          item.ItemList.forEach((obj, index) => {
            this.CpartScoreList[num].push(0)
            this.EpartScoreList[num].push(0)
          })
        })
      }
    },
  }
</script>

<style lang="less" scoped>
  .block {
    display: flex;
    margin-top: 20px;

    .demonstration {
      width: 30%;
      text-align: right;
    }

    .icon {
      width: 70%;
      padding-left: 15px;
    }
  }
</style>
